import React, { useState } from "react";
import "./AddPhotographerModal.css";
import { AddPhotographerAPI } from "../../../utils/APIs/photographersApis";
import { toast } from "react-toastify";
import Loader from "../../../Loader/Loader";

const AddPhotographerModal = ({ isOpen, onClose, onAdd }) => {
  const[loading,setLoading]=useState(false)
  const [formData, setFormData] = useState({
    name: "",
    displayName: "",
    email: "",
    phone: "",
    experience: "",
    city: "",
    signupDate: "",
    photographerType: "Photographer",
    expertiseLevel: "INITIO",
    gstRegistered: "No",
    gstNumber: "",
    hasStudio: "No",
    studioName: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Automatically set default expertise when type changes
    if (name === "photographerType") {
      const isEditor = value?.trim()?.toLowerCase() === "editor";
      setFormData((prev) => ({ 
        ...prev, 
        [name]: value, 
        expertiseLevel: isEditor ? "STANDARD" : "INITIO" 
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }

    if (errors[name]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.displayName.trim()) newErrors.displayName = "Display Name is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    if (!formData.phone.trim()) newErrors.phone = "Phone is required";
    if (!formData.experience.trim()) newErrors.experience = "Experience is required";
    if (!formData.city.trim()) newErrors.city = "City is required";
    if (!formData.signupDate) newErrors.signupDate = "Sign-up date is required";
    if (!formData.photographerType) newErrors.photographerType = "Photographer type is required";
    if (formData.gstRegistered === "Yes" && !formData.gstNumber.trim()) {
      newErrors.gstNumber = "GST Number is required";
    }
    if (formData.hasStudio === "Yes" && !formData.studioName.trim()) {
      newErrors.studioName = "Studio Name is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      const firstError = Object.values(newErrors)[0];
      toast.error(firstError);
      return;
    }

    setLoading(true);

    const payload = {
      name: formData.name,
      displayName: formData.displayName,
      email: formData.email,
      phone: formData.phone,
      experience: formData.experience,
      city: formData.city,
      signUpDate: formData.signupDate,
      photographerType: formData.photographerType,
      expertiseLevel: formData.expertiseLevel,
      gstRegistered: formData.gstRegistered === "Yes",
      gstNumber: formData.gstRegistered === "Yes" ? formData.gstNumber : "",
      hasStudio: formData.hasStudio === "Yes",
      studioName: formData.hasStudio === "Yes" ? formData.studioName : "",
    };

    try {
      const res = await AddPhotographerAPI(payload);

      if (res?.data?.success) {
        toast.success(res?.data?.message || "Photographer added successfully");
        if (onAdd && res?.data?.photographer) {
          onAdd(res.data.photographer);
          setFormData({
            name: "",
            displayName: "",
            email: "",
            phone: "",
            experience: "",
            city: "",
            signupDate: "",
            photographerType: "Photographer",
            expertiseLevel: "INITIO",
            gstRegistered: "No",
            gstNumber: "",
            hasStudio: "No",
            studioName: "",
          });
          onClose();
        }
      } else {
        toast.error(res?.data?.message || "Failed to add photographer");
      }
    } catch (error) {
      console.error("Failed to add photographer:", error);
      const errorMsg = error.response?.data?.message || error.response?.data?.error || "Failed to add photographer";
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };


  if (!isOpen) return null;

  if(loading){
    return<Loader/>
  }

  return (
    <div className="photographer-modal-overlay">
      <div className="photographer-add-modal-content">
        <h2>Add New Photographer</h2>
        <form onSubmit={handleSubmit} className="add-form">
          <div className="form-grid">
            <div className="form-group">
            <label>Name:</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className={errors.name ? "error-input" : ""}
            />
            {errors.name && <span className="error-msg">{errors.name}</span>}
          </div>

          <div className="form-group">
            <label>Display Name:</label>
            <input
              type="text"
              name="displayName"
              value={formData.displayName}
              onChange={handleChange}
              className={errors.displayName ? "error-input" : ""}
            />
            {errors.displayName && <span className="error-msg">{errors.displayName}</span>}
          </div>

          <div className="form-group">
            <label>Email:</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={errors.email ? "error-input" : ""}
            />
            {errors.email && <span className="error-msg">{errors.email}</span>}
          </div>

          <div className="form-group">
            <label>Phone:</label>
            <input
              type="text"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className={errors.phone ? "error-input" : ""}
            />
            {errors.phone && <span className="error-msg">{errors.phone}</span>}
          </div>

          <div className="form-group">
            <label>Experience:</label>
            <input
              type="text"
              name="experience"
              value={formData.experience}
              onChange={handleChange}
              className={errors.experience ? "error-input" : ""}
            />
            {errors.experience && <span className="error-msg">{errors.experience}</span>}
          </div>

          <div className="form-group">
            <label>City:</label>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleChange}
              className={errors.city ? "error-input" : ""}
            />
            {errors.city && <span className="error-msg">{errors.city}</span>}
          </div>

          <div className="form-group">
            <label>Sign-Up Date:</label>
            <input
              type="date" onClick={(e) => { if(e.target.showPicker) e.target.showPicker(); }}
              name="signupDate"
              value={formData.signupDate}
              onChange={handleChange}
              className={errors.signupDate ? "error-input" : ""}
            />
            {errors.signupDate && <span className="error-msg">{errors.signupDate}</span>}
          </div>

          <div className="form-group">
            <label>Photographer Type:</label>
            <select
              name="photographerType"
              value={formData.photographerType}
              onChange={handleChange}
              className={errors.photographerType ? "error-input" : ""}
            >
              <option value="Photographer">Photographer</option>
              <option value="Videographer">Videographer</option>
              <option value="Editor">Editor</option>
              <option value="Lighting Setup">Lighting Setup</option>
            </select>
            {errors.photographerType && <span className="error-msg">{errors.photographerType}</span>}
          </div>

          <div className="form-group">
            <label>Expertise Level:</label>
            <select
              name="expertiseLevel"
              value={formData.expertiseLevel}
              onChange={handleChange}
            >
              {formData.photographerType?.trim()?.toLowerCase() === "editor" ? (
                <>
                  <option value="STANDARD">STANDARD</option>
                  <option value="PREMIUM">PREMIUM</option>
                </>
              ) : (
                <>
                  <option value="INITIO">INITIO</option>
                  <option value="ELITE">ELITE</option>
                  <option value="PRO">PRO</option>
                </>
              )}
            </select>
          </div>

          <div className="form-group">
            <label>GST Registered:</label>
            <select
              name="gstRegistered"
              value={formData.gstRegistered}
              onChange={handleChange}
            >
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>

          {formData.gstRegistered === "Yes" && (
            <div className="form-group">
              <label>GST Number:</label>
              <input
                type="text"
                name="gstNumber"
                value={formData.gstNumber}
                onChange={handleChange}
                className={errors.gstNumber ? "error-input" : ""}
              />
              {errors.gstNumber && <span className="error-msg">{errors.gstNumber}</span>}
            </div>
          )}

          <div className="form-group">
            <label>Studio:</label>
            <select
              name="hasStudio"
              value={formData.hasStudio}
              onChange={handleChange}
            >
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>

          {formData.hasStudio === "Yes" && (
            <div className="form-group">
              <label>Studio Name:</label>
              <input
                type="text"
                name="studioName"
                value={formData.studioName}
                onChange={handleChange}
                className={errors.studioName ? "error-input" : ""}
              />
              {errors.studioName && <span className="error-msg">{errors.studioName}</span>}
            </div>
          )}
          </div>

          <div className="modal-actions">
            <button type="button" className="btn-cancel" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn-add">
              Add
            </button>
            
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddPhotographerModal;
